import React, { Component } from 'react';
import { CleaveOptions } from 'cleave.js/options';

import BaseFilter from './BaseFilter';
import { H3 } from '../Typography';
import { Input } from '../Forms';

export type OnChangeFunction = (event: Event) => void;

export interface InputProperty {
    name: string;
    label: string;
    value: string;
    placeholder: string;
    type: string;
    options?: CleaveOptions;
    maxLength?: number;
    disabled?: boolean;
    prefix?: string;
    validate?: (value: string) => string | undefined;
}

export interface ApplyResult {
    [name: string]: string;
} 

interface MultiInputFilterProps<Result extends ApplyResult>{
    name: string;
    title: string;
    disabled?: boolean;
    label: string;
    fields: InputProperty[];
    onApply: (filterState: Result) => void;
    onDelete: (name: string) => void;
}

interface TextInputProps {
    name: string;
    value: string;
    label: string;
    placeholder: string;
    type: string;
    options?: CleaveOptions;
    onChange: (name: string, value: string) => void;
    autoFocus?: boolean;
    maxLength?: number;
    disabled?: boolean;
    prefix?: string;
    validate?: (value: string) => string | undefined;
}

interface FilterSelectState {
    [key: string]: string;
}

const TextInput = ({ name, value,  label, onChange, placeholder, autoFocus }: TextInputProps) => {
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLTextAreaElement;
        const name = target.name as 'pendingTop' | 'pendingBottom';
        onChange(name, target.value);
    };

    return (
        <Input
            label={label}
            placeholder={placeholder}
            type="text"
            name={name}
            value={value}
            onChange={handleChange}
            onBlur={() => {}}
            autoComplete="off"
            autoFocus={autoFocus}
        />
    );
};

class MultiInputFilter extends Component<MultiInputFilterProps<ApplyResult>, FilterSelectState> {
    constructor(props: MultiInputFilterProps<ApplyResult>, context: any) {
        super(props, context);

        const { fields } = this.props;

        this.state = fields.reduce((acc, field) => {
            return { ...acc, [field.name]: field.value };
        }, {});
    }

    handleChange = (name: string, value: string) => {
        const nextState = { [name]: value } as Pick<FilterSelectState, keyof FilterSelectState>;
        this.setState(nextState);
    };

    render() {
        const { title, name, onApply, onDelete, disabled, label, fields } = this.props;
        const initialOpen = fields.filter(x => x.value).length === 0;
        return (
            <BaseFilter
                initialOpen={initialOpen}
                label={label}
                disabled={disabled}
                name={name}
                onApply={() => {
                    onApply({ ...this.state } as ApplyResult);
                }}
                onDelete={() => {
                    onDelete(name);
                }}
            >
                <H3>{title}</H3>
                {fields.map((field, i) => 
                    <TextInput
                        key={field.name}
                        name={field.name}
                        label={field.label}
                        value={this.state[field.name]}
                        autoFocus={i===0}
                        onChange={this.handleChange}
                        options={field.options}
                        placeholder={field.placeholder}
                        type={field.type}
                        maxLength={field.maxLength}
                        prefix={field.prefix}
                        validate={field.validate}
                    />)}
            </BaseFilter>
        );
    }
}

export default MultiInputFilter;
